<app-card-loader *ngIf="($loading | async)"></app-card-loader>

<ng-container *ngIf="!($loading | async)">

  <h1>Edit Profile</h1>

  <div class="card mt-7">

    <div class="card-body card-body-sm">

      <form [formGroup]="EditProfileForm" (submit)="submitForm()">

        <div class="row">

          <ng-container>
            <div class="col-md-6">

              <div class="fv-row mb-10">
                <label class="form-label fs-6 text-dark">First Name *</label>
                <input
                  class="form-control"
                  type="text"
                  name="name"
                  formControlName="name"
                  autocomplete="off"
                  [ngClass]="{
                  'is-invalid': EditProfileForm.controls['name'].invalid && EditProfileForm.controls['name'].touched,
                  'is-valid': EditProfileForm.controls['name'].valid
                }"
                />
              </div>

            </div>

            <div class="col-md-6">

              <div class="fv-row mb-10">
                <label class="form-label fs-6 text-dark">Email <small>[Cannot be changed]</small></label>
                <input
                  class="form-control form-control-solid"
                  type="text"
                  name="last_name"
                  [disabled]="true"
                  readonly
                  formControlName="email"
                  autocomplete="off"
                  [ngClass]="{
                  'is-invalid': EditProfileForm.controls['email'].invalid && EditProfileForm.controls['email'].touched,
                  'is-valid': EditProfileForm.controls['email'].valid
                }"
                />
              </div>

            </div>
          </ng-container>


          <div class="col-md-6">

            <div class="fv-row mb-10">
              <label class="form-label fs-6 text-dark">Profile picture</label>
              <app-inline-file-upload [existingURL]="currentUser.profile_picture" formControlName="profile_picture_upload" type="image"></app-inline-file-upload>
            </div>

          </div>

        </div>

        <div class="text-align-right w-100">
          <button class="btn btn-theme btn-lg ms-3" type="submit">Save</button>
        </div>

      </form>


    </div>

  </div>


  <ng-template
    #formError
    let-control="control"
    let-message="message"
    let-validation="validation"
  >
    <ng-container
      *ngIf="control.hasError(validation) && (control.dirty || control.touched)"
    >
      <div class="fv-plugins-message-container">
      <span role="alert">
        {{ message }}
      </span>
      </div>
    </ng-container>
  </ng-template>


</ng-container>
